import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { focusAtom } from 'jotai-optics';

import { LocationDetails } from '@cfa/pathway-fe-shared/xp';

export const LICENSEE_LOCATION_DEFAULTS = {
  selected: null as LocationDetails | null,
  shouldShowPicker: false,
};

export const licenseeLocationBaseAtom = atomWithStorage(
  'app.licensee.location',
  LICENSEE_LOCATION_DEFAULTS,
);

const base = licenseeLocationBaseAtom;

type Action = ['setActive', LocationDetails | null] | ['show'] | ['hide'];

export const licenseeLocationAtom = atom(
  get => get(base),
  (get, set, ...args: Action) => {
    const [action, payload] = args;
    const prev = get(base);
    switch (action) {
      case 'hide':
        return set(base, { ...prev, shouldShowPicker: false });
      case 'show':
        return set(base, { ...prev, shouldShowPicker: true });
      case 'setActive':
        return set(base, {
          ...prev,
          selected: payload,
        });
    }
  },
);

export const activeLicenseeLocationAtom = focusAtom(base, o =>
  o.prop('selected'),
);
